let resumeData = {
    "imagebaseurl" : "http://localhost:3000/",
    "name": "Brent Feuerbacher",
    "role": "Full Stack Developer"
}

export default resumeData;